import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from "react-loader";
import { toast, ToastContainer } from "react-toastify";
import {
  Button,
  Col,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";

import FormModal from "../../../../components/Admin/FormModal/FormModal";
import FormFieldClass from "../../../../components/Admin/FormModal/FormFieldClass";

import Navbar from "../../../../components/CustomNav/CustomNav.Component";
import withServices from "../../../../HOCs/withServices";
import { Wrapper, Content, ContentRow } from "./SingleSchool.styles";

import SimpleLoader from "../../../../components/SimpleLoader/SimpleLoader.Component";

import { CSVLink } from "react-csv";

import { SOCKET as socket } from "../../../../common/constants";
import { decodeSocketMessage } from "src/common/utils";

interface IProps {
  services?: any;
  location?: any;
  match?: any;
  history?: any;
}

interface IState {
  toLogin: boolean;
  loaded: boolean;
  data: any;
  selectedLesson: string;
  isNavigate: boolean;
  destination: string;
}

class SingleSchool extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      destination: "",
      toLogin: false,
      loaded: true,
      isNavigate: false,
      data: {},
      selectedLesson: "",
    };

    this.onLogout = this.onLogout.bind(this);
    this.onGoBack = this.onGoBack.bind(this);
    this.urnModalToggle = this.urnModalToggle.bind(this);
    this.urnSubmit = this.urnSubmit.bind(this);
    this.deptModalToggle = this.deptModalToggle.bind(this);
    this.deptSubmit = this.deptSubmit.bind(this);
    this.reportGenerate = this.reportGenerate.bind(this);
    this.verifyScores = this.verifyScores.bind(this);
    this.completionReport = this.completionReport.bind(this);
    this.reportModalToggle = this.reportModalToggle.bind(this);
    this.reportSubmit = this.reportSubmit.bind(this);
    this.executiveReport = this.executiveReport.bind(this);
    this.assessmentTriggerModalToggle =
      this.assessmentTriggerModalToggle.bind(this);
    this.manualAssessmentSubmit = this.manualAssessmentSubmit.bind(this);
    this.onSetup = this.onSetup.bind(this);
    this.onMessage = this.onMessage.bind(this);
    this.rebuildSubmit = this.rebuildSubmit.bind(this);
    this.rebuildToggle = this.rebuildToggle.bind(this);
  }

  public onSocketConnect = () => {
    console.log("connected");
  };

  public onMessage(socketResponse) {
    console.log("SOcketMessage: ", socketResponse);
    const socketMessage = decodeSocketMessage(socketResponse);
    toast.success(
      `Students Assigned: ${socketMessage.message.data.total_completed}`
    );

    const data = this.state.data;

    data.processing = false;

    this.setState({ data });
  }

  public onSetup = (message) => {
    console.log("setup");
    console.log(message);
    const data = this.state.data;

    data.sid = message.id;

    this.setState({ data });
  };

  public customTD = (props) => {
    return (
      <td>
        {/*tslint:disable-next-line jsx-no-lambda*/}
        <Button onClick={() => this.reportGenerate(props)}>
          Generate Reports
        </Button>
      </td>
    );
  };

  public onGoBack() {
    const dest = this.props.services.currentBaseUrl + "institutions";

    this.setState({
      isNavigate: true,
      destination: dest,
    });
  }

  public onLogout() {
    this.setState({ toLogin: true });
  }

  public async reportGenerate(row) {
    const userid = row.rowData.User__id;

    const {
      services: { isUserLoggedIn, adminAPI, currentUserID },
    } = this.props;

    const reportRes = await adminAPI.genReports(userid);

    if (reportRes.ok) {
      toast.success("Generating reports");
    }
  }

  public componentWillUnmount() {
    console.log("removing sockets");

    socket.off("customNotif");
  }

  public async componentDidMount() {
    socket.on("connect", this.onSocketConnect);

    socket.on("customEmit", (data) => this.onSetup(data));

    socket.on("customNotif", (data) => this.onMessage(data));

    const {
      match,
      history,
      location,
      services: { isUserLoggedIn, adminAPI, currentUserID },
    } = this.props;

    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
    }

    const {
      params: { id: schoolID },
    } = match;

    const studentsDataKey = [
      "User__id",
      "User__username",
      "PreAssesmentDone",
      "UpgradedPreAssesmentDone",
      "UserGroup",
      "ParentStudentCode",
      "generate",
    ];

    const studentsThead = [
      "ID",
      "Name",
      "0.5 Done",
      "1.0 Done",
      "UserType",
      "Code",
      "Action",
    ];

    const membersRes = await adminAPI.getSchoolMembers(schoolID);

    const assessmentsRes = await adminAPI.getOrganisationAssessments(schoolID);

    const assessmentsAllRes = await adminAPI.getAssessments();

    const rebuildFormValues = {
      Assessment: "",
      Description: "",
    };

    if (membersRes.ok && assessmentsRes.ok) {
      const rebuildFormFields = [
        {
          id: "Assessment",
          name: "Assessment",
          type: "option",
          placeholder: "Enter Assessment",
          options: {
            items: assessmentsRes.data.assessments,
            idkey: "id",
            labelkey: "name",
            valuekey: "id",
          },
          required: true,
        },
        {
          id: "Description",
          name: "Description",
          type: "text",
          placeholder: "Enter Description",
          required: false,
        },
      ] as FormFieldClass[];

      const students = membersRes.data.users;

      this.setState({
        data: {
          deptModal: false,
          students,
          assessments: assessmentsRes.data.assessments,
          assessmentsAll: assessmentsAllRes.data.assessments,
          rebuildFormFields,
          rebuildFormValues,
          loaded: true,
          reportModal: false,
          schoolID,
          studentsDataKey,
          studentsThead,
          uploading: false,
          urnModal: false,
          rebuildModal: false,
          assessmentTriggerModal: false,
          processing: false,
          sid: null,
        },
      });
    } else {
      toast.error("Error fetching interaction details!");
    }

    socket.emit("customMsg", { evt: "init" });
  }

  public urnModalToggle() {
    const data = this.state.data;

    data.urnModal = !data.urnModal;

    this.setState({ data });
  }

  public reportModalToggle() {
    const data = this.state.data;

    data.reportModal = !data.reportModal;

    this.setState({ data });
  }

  public assessmentTriggerModalToggle() {
    const data = this.state.data;

    data.assessmentTriggerModal = !data.assessmentTriggerModal;

    this.setState({ data });
  }

  public deptModalToggle() {
    const data = this.state.data;

    data.deptModal = !data.deptModal;

    this.setState({ data });
  }

  public async rebuildSubmit(e) {
    e.preventDefault();

    const data = this.state.data;

    data.uploading = true;

    this.setState({ data });

    const item = this.state.data.rebuildFormValues;

    const res = await this.props.services.adminAPI.rebuildInstitutionScores(
      data.schoolID,
      item.Assessment,
      data.sid
    );

    if (res.ok) {
      toast.info("Rebuild started...");
      this.rebuildToggle();
    } else {
      toast.error("Rebuild failed, try again");
    }
  }

  public async urnSubmit(e) {
    e.preventDefault();

    const data = this.state.data;

    data.uploading = true;

    this.setState({ data });

    const fileInputElement = e.target.elements.upld;
    const formData = new FormData();

    for (const row of fileInputElement.files) {
      formData.append("files", row);
    }

    const res = await this.props.services.adminAPI.updloadUrn(
      formData,
      data.schoolID
    );

    if (res.ok) {
      const studentsRes = await this.props.services.adminAPI.getSchoolMembers(
        data.schoolID
      );

      if (studentsRes.ok) {
        const students = studentsRes.data.users;

        const data = this.state.data;

        data.students = students;

        data.uploading = false;

        data.urnModal = false;

        this.setState({ data });

        toast.success("Success");
      }
    } else {
      toast.error("Failed to complete upload");
    }

    data.uploading = false;

    this.setState({ data });
  }

  public async verifyScores() {
    const data = this.state.data;

    const res = await this.props.services.adminAPI.verifyInstitutionScores(
      data.schoolID
    );

    if (res.ok) {
      toast.success("Success");
    } else {
      toast.error("Failed to complete request");
    }
  }

  public async completionReport() {
    const data = this.state.data;

    const res = await this.props.services.adminAPI.institutionCompletionReport(
      data.schoolID
    );

    if (res.ok) {
      toast.success("Success");
    } else {
      toast.error("Failed to complete request");
    }
  }

  public async executiveReport() {
    const data = this.state.data;

    const res = await this.props.services.adminAPI.institutionExecutiveReport(
      data.schoolID
    );

    if (res.ok) {
      toast.success("Success");
    } else {
      toast.error("Failed to complete request");
    }
  }

  public async reportSubmit(e) {
    e.preventDefault();

    const data = this.state.data;

    data.uploading = true;

    this.setState({ data });

    const endDate = e.target.elements.enddate.value;

    const res = await this.props.services.adminAPI.institutionCompletionReport(
      data.schoolID,
      endDate
    );

    if (res.ok) {
      toast.success("Success");
    } else {
      toast.error("Failed to complete request");
    }

    data.uploading = false;

    data.reportModal = false;

    this.setState({ data });
  }

  public async manualAssessmentSubmit(e) {
    e.preventDefault();

    const data = this.state.data;

    data.uploading = true;

    this.setState({ data });

    const assessmentId = e.target.elements.assessment.value;

    const res =
      await this.props.services.adminAPI.manualTriggerInstitutionAssessment(
        data.schoolID,
        assessmentId,
        data.sid
      );

    if (res.ok) {
      toast.success("Success");
      data.processing = true;
    } else {
      toast.error("Failed to complete request");
    }

    data.uploading = false;

    data.assessmentTriggerModal = false;

    this.setState({ data });
  }

  public async deptSubmit(e) {
    e.preventDefault();

    const data = this.state.data;

    data.uploading = true;

    this.setState({ data });

    const fileInputElement = e.target.elements.upld;
    const formData = new FormData();

    for (const row of fileInputElement.files) {
      formData.append("files", row);
    }

    const res = await this.props.services.adminAPI.updloadDept(
      formData,
      data.schoolID
    );

    if (res.ok) {
      const studentsRes = await this.props.services.adminAPI.getSchoolMembers(
        data.schoolID
      );

      if (studentsRes.ok) {
        const students = studentsRes.data.users;

        const data = this.state.data;

        data.students = students;

        data.uploading = false;

        data.urnModal = false;

        this.setState({ data });

        toast.success("Success");
      }
    } else {
      toast.error("Failed to complete upload");
    }

    data.uploading = false;

    this.setState({ data });
  }

  public rebuildToggle() {
    const data = this.state.data;
    data.rebuildModal = !data.rebuildModal;

    console.log(data.rebuildModal);

    this.setState({ data });
  }

  public TemplateOPtions(options) {
    return options.map((d, i) => (
      <option key={d.id} value={d.id}>
        {d.Title}
      </option>
    ));
  }

  public render() {
    const { data } = this.state;

    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }

    if (this.state.isNavigate) {
      return <Redirect to={this.state.destination} />;
    }

    if (Object.keys(data).length === 0) {
      return <Loader color="#acff24" />;
    }

    return (
      <Wrapper>
        <ToastContainer />
        <Navbar logoutParent={this.onLogout} />
        <Content>
          <ContentRow className="single-col">
            <p className="go-back" onClick={this.onGoBack}>
              &lt; Back
            </p>
          </ContentRow>
        </Content>

        {data.processing ? <SimpleLoader text="PL is working..." /> : ""}

        <Content>
          <Button onClick={this.urnModalToggle}>Upload URN</Button>

          <Button onClick={this.deptModalToggle} style={{ marginLeft: "5px" }}>
            Upload Department Data
          </Button>

          <Button onClick={this.executiveReport} style={{ marginLeft: "5px" }}>
            Executive Report
          </Button>

          <Button
            onClick={this.reportModalToggle}
            style={{ marginLeft: "5px" }}
          >
            Completion Report
          </Button>

          <Button
            onClick={this.assessmentTriggerModalToggle}
            style={{ marginLeft: "5px" }}
          >
            Trigger Assessment
          </Button>

          <CSVLink
            style={{ marginLeft: "19px" }}
            data={data.students}
            headers={data.studentsDataKey}
          >
            Download
          </CSVLink>

          <SortableTbl
            tblData={data.students}
            tHead={data.studentsThead}
            dKey={data.studentsDataKey}
            customTd={[
              { custd: this.customTD, keyItem: "generate", sortable: false },
            ]}
            defaultCSS={false}
          />
        </Content>

        <Content>
          <Modal
            isOpen={data.urnModal}
            toggle={this.urnModalToggle}
            style={{ marginTop: "10%" }}
          >
            <ModalHeader toggle={this.urnModalToggle}>
              {" "}
              Students Upload
            </ModalHeader>
            <ModalBody>
              <form onSubmit={this.urnSubmit}>
                <Row>
                  <Col xs="12">
                    <input
                      id="upld"
                      type="file"
                      name="upld"
                      accept=".csv"
                      multiple={false}
                      required={true}
                    />
                  </Col>

                  <Loader color="#3EE9F7" loaded={!data.uploading}>
                    <Button
                      color="primary"
                      type="submit"
                      className="adminmodalbutton"
                    >
                      Submit
                    </Button>
                    <Button
                      onClick={this.urnModalToggle}
                      className="adminmodalbutton"
                    >
                      Cancel
                    </Button>
                  </Loader>
                </Row>
              </form>
            </ModalBody>
          </Modal>
          <Modal
            isOpen={data.deptModal}
            toggle={this.deptModalToggle}
            style={{ marginTop: "10%" }}
          >
            <ModalHeader toggle={this.deptModalToggle}>
              {" "}
              Extra Data Upload
            </ModalHeader>
            <ModalBody>
              <form onSubmit={this.deptSubmit}>
                <Row>
                  <Col xs="12">
                    <input
                      id="upld"
                      type="file"
                      name="upld"
                      accept=".csv"
                      multiple={false}
                      required={true}
                    />
                  </Col>

                  <Loader color="#3EE9F7" loaded={!data.uploading}>
                    <Button
                      color="primary"
                      type="submit"
                      className="adminmodalbutton"
                    >
                      Submit
                    </Button>
                    <Button
                      onClick={this.deptModalToggle}
                      className="adminmodalbutton"
                    >
                      Cancel
                    </Button>
                  </Loader>
                </Row>
              </form>
            </ModalBody>
          </Modal>
          <Modal
            isOpen={data.reportModal}
            toggle={this.reportModalToggle}
            style={{ marginTop: "10%" }}
          >
            <ModalHeader toggle={this.reportModalToggle}>
              {" "}
              Generate a report
            </ModalHeader>
            <ModalBody>
              <Loader color="#3EE9F7" loaded={!data.uploading}>
                <Button
                  color="primary"
                  type="submit"
                  className="adminmodalbutton"
                >
                  Submit
                </Button>
                <Button
                  onClick={this.reportModalToggle}
                  className="adminmodalbutton"
                >
                  Cancel
                </Button>
              </Loader>
            </ModalBody>
          </Modal>

          <ContentRow>
            <FormModal
              visible={data.rebuildModal}
              toggle={this.rebuildToggle}
              formsubmit={this.rebuildSubmit}
              formfields={data.rebuildFormFields}
              values={data.rebuildFormValues}
              isbusy={data.uploading}
            />
          </ContentRow>

          <Modal
            isOpen={data.assessmentTriggerModal}
            toggle={this.assessmentTriggerModalToggle}
            style={{ marginTop: "10%" }}
          >
            <ModalHeader toggle={this.assessmentTriggerModalToggle}>
              {" "}
              Trigger Assessment
            </ModalHeader>
            <ModalBody>
              <form onSubmit={this.manualAssessmentSubmit}>
                <select
                  name="assessment"
                  data-arg="assessment"
                  id="assessment"
                  required={true}
                  className="custom-select"
                >
                  <option value="" selected={true}>
                    {" "}
                    Choose an Assessment{" "}
                  </option>

                  {this.TemplateOPtions(data.assessmentsAll)}
                </select>

                <Loader color="#3EE9F7" loaded={!data.uploading}>
                  <Button
                    color="primary"
                    type="submit"
                    className="adminmodalbutton"
                  >
                    Submit
                  </Button>
                  <Button
                    onClick={this.assessmentTriggerModalToggle}
                    className="adminmodalbutton"
                  >
                    Cancel
                  </Button>
                </Loader>
              </form>
            </ModalBody>
          </Modal>
        </Content>
      </Wrapper>
    );
  }
}

export default withServices(SingleSchool);



// WEBPACK FOOTER //
// ./src/pages/Admin/Schools/SingleSchool/SingleSchool.tsx